import { JSXElement, mergeProps } from 'solid-js';

type AgentPortalLayoutProps = {
  children: JSXElement;
};

export default function AgentPortalLayout(
  props: AgentPortalLayoutProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <div
      class={
        'flex items-center justify-center w-full min-h-screen bg-bg-disabled'
      }
    >
      {merged.children}
    </div>
  );
}
